import React from 'react';
import './MenuTop.css';
import logo from '../../images/logo-sm-black.png';
import { Affix, Button, Col, Dropdown, Menu, Icon, Row } from 'antd';
import Link from 'react-router-dom/Link';
// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;

class MenuTop extends React.Component {
  state = { 
    current: this.props.pageOn,
    showVerticalDropdown: false
  };  

  componentDidMount(){
    
    function myFunction() {
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      var scrolled = (winScroll / height) * 100;
      // console.log('scrolled: ' + scrolled);
      document.getElementById("myBar").style.width = scrolled + "%";
    }
    window.onscroll = function() {myFunction()};
  }

  handleTopMenuClick = (e) => {
    console.log('click ', e);
    this.setState((prevState, props) => ({    
      current: e.key,
      showVerticalDropdown: false}));
  }

  handleToggleVerticalDropdown = (e) => {
    this.setState({
      showVerticalDropdown: !this.state.showVerticalDropdown
    });
  }

   render(){

      const dropDownMenu = (
        <div className="MenuTop--container center">
          <div className="MenuTop--container-horizontal-holder center">
            <Menu className="MenuTop--container-horizontal" theme="dark">
              <Menu.Item key="faq">
                <Link to="/faq/"><Icon type="bars" />FAQ</Link>
              </Menu.Item>
               <Menu.Item key="market">
                <Link to="/market/"><Icon type="line-chart" />Market</Link>
              </Menu.Item>
              <Menu.Item key="applications">
                <Link to="/applications/"> <Icon type="solution" />Use Cases</Link>
              </Menu.Item>
              <Menu.Item key="videos">
                <Link to="/videos/"><Icon type="youtube" />Videos</Link>
              </Menu.Item>
            </Menu>
          </div>
        </div>
      );

      return (
      <div className="MenuTop--container center">
        <div className="MenuTop--container-horizontal-holder center">
        <Affix>
          <Menu
            onClick={this.handleTopMenuClick}
            selectedKeys={[this.state.current]}
            mode="horizontal"
            className="MenuTop--container-horizontal"
            theme="dark"
            >
              <Menu.Item key="home">
                <Link to="/"><img id="logo" src={logo} alt="logo" className="logo"/></Link>
              </Menu.Item>
              <Menu.Item key="whatis">
                <Link to="/"><Icon type="home" />What is Real Time Touch?</Link>
              </Menu.Item>
              {/* <Menu.Item key="applications">
                <Link to="/applications/"> <Icon type="solution" />Applications</Link>
              </Menu.Item> */}
              <Menu.Item key="patents">
                <Link to="/patents/"><Icon type="copy" />Patents</Link>
              </Menu.Item>
              <Menu.Item key="remoterx">
                <Link to="/remoterx/"><Icon type="file-pdf" />Remote Rx</Link>
              </Menu.Item>
              {/* <Menu.Item key="market">
                <Link to="/market/"><Icon type="line-chart" />Market</Link>
              </Menu.Item> */}
              <Menu.Item key="metaverse">
                <Link to="/metaversehealth/"><Icon type="line-chart" />Metaverse</Link>
              </Menu.Item>
              <Menu.Item key="updates" >
                <Link to="/updates/"><Icon type="rocket" />Updates</Link>
              </Menu.Item>
              {/* <Menu.Item key="videos">
                <Link to="/videos/"><Icon type="youtube" />Videos</Link>
              </Menu.Item>
              <Menu.Item key="faq">
                <Link to="/faq/"><Icon type="bars" />FAQ</Link>
              </Menu.Item> */}
              <Menu.Item key="info">
                <Dropdown overlay={dropDownMenu}>
                  <a className="ant-dropdown-link" href="#">
                  <Icon type="info-circle"/>Info <Icon type="down"/></a>
                </Dropdown>
              </Menu.Item>
              <Menu.Item key="contact" style={{marginLeft:-15}}>
                <Link to="/contact/"><Icon type="message" />Contact</Link>
              </Menu.Item>

            </Menu>
            <div className="progress-container">
              <div className="progress-bar" id="myBar"></div>
            </div>  
          </Affix>
        </div>
 
        <Affix>
        <div className="MenuTop--container-vertical">
            <Row className="MenuTop--row-vertical">
              <Col span={4} className="MenuTop--vertical-col1">
              <Link to="/">
                <img id="logo" src={logo} alt="logo" className="MenuTop--vertical-logo"/> 
              </Link> 
              </Col>
              <Col span={16} className="MenuTop--vertical-col2">
                  <div className="MenuTop--vertical-logo">
                    {/* <img src="" style={{display: inline}}/> */} 
                    <Link to="/"> 
                      <span className="MenuTop--vertical-logo-text">Real Time Touch</span>
                    </Link> 
                    </div>
              </Col>
              <Col span={4} className="MenuTop--vertical-col3">
                  <a className="ant-dropdown-link" onClick={this.handleToggleVerticalDropdown}>
                  <Button className="MenuTop--vertical-button" type="primary" onClick={this.toggleCollapsed} style={{ marginBottom: 12 }}>
          <Icon type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'} />
        </Button>
                  </a>
              </Col>
            </Row>
            <div className={this.state.showVerticalDropdown ? " MenuTop--row-vertical-dropdown-open" : " MenuTop--row-vertical-dropdown"}>
              <Row style={{marginBottom:10}}>
                  <Menu className="MenuTop--row-vertical-dropdown-container" theme="dark">
                  <Menu.Item key="remoterx">
                    <Link to="/remoterx/"><Icon type="file-pdf" />Remote Rx</Link>
                  </Menu.Item>
                    <Menu.Item key="whatis">
                      <Link to="/"><Icon type="home" />What is Real Time Touch?</Link>
                    </Menu.Item>
                    <Menu.Item key="applications">
                      <Link to="/applications/"> <Icon type="solution" />Use Cases</Link>
                    </Menu.Item>
                    <Menu.Item key="patents">
                      <Link to="/patents/"><Icon type="copy" />Patents</Link>
                    </Menu.Item>
                    <Menu.Item key="market">
                      <Link to="/market/"><Icon type="line-chart" />Market</Link>
                    </Menu.Item>
                    <Menu.Item key="updates">
                      <Link to="/updates/"><Icon type="rocket" />Updates</Link>
                    </Menu.Item>
                    <Menu.Item key="videos">
                      <Link to="/videos/"><Icon type="youtube" />Videos</Link>
                    </Menu.Item>
                    <Menu.Item key="faq">
                      <Link to="/faq/"><Icon type="bars" />FAQ</Link>
                    </Menu.Item>
                    <Menu.Item key="contact">
                      <Link to="/contact/"><Icon type="message" />Contact</Link>
                    </Menu.Item>
                  </Menu>
              </Row>
            </div>
        </div>
        </Affix>
      </div>
      )
   }
 }

export default MenuTop;


// WEBPACK FOOTER //
// ./src/common/MenuTop/MenuTop.js